import { environment } from 'src/environments/environment';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { NotificationService } from './../../core/services/notification-data.service';
import {
  Component,
  ElementRef,
  HostListener,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MenuService } from 'src/app/core/services/menu.service';
import { NotificationItem } from 'src/app/core/models/notification-item';
import { from, Observable, zip } from 'rxjs';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { LaasConstants } from 'src/app/core/constants/laas-constants.constant';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserType } from 'src/app/core/enums/user-type.enum';
import {
  extractLinkPath,
  initLaasPortalVersion,
  isDeepLinkAvailable,
  isNullOrEmpty,
} from 'src/app/core/utils/common-functions';
import { UserRefreshToken } from 'src/app/core/models/user-refreshToken';
import { OverlayPanel } from 'primeng/overlaypanel';
import { clearDetectorDetectInterval } from 'src/app/shared/devtools/utils/interval';
import { disableKeyAndMenu } from 'src/app/shared/devtools/utils/key-menu';
import { config as devToolsConfig } from 'src/app/shared/devtools/utils/config';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import { MenuItem, PrimeNGConfig } from 'primeng/api';
import * as _ from 'lodash';
import { GlobalConstants } from 'src/app/core/constants/global-constants.constant';
import {
  UserFavoriteMenuResp,
  UserFavoriteMenuItemBean,
} from 'src/app/core/models/menu/user-favorite-menu-resp';
import { Router } from '@angular/router';

@Component({
  selector: 'laas-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends SessionBaseComponent {
  language: string;
  languageData: any;
  languageOptions: any[] = [];
  bellNotifications: NotificationItem[] = [];
  showBellNotifications: NotificationItem[] = [];
  showAllBellNotify: boolean = true;
  isLoading: boolean = false;
  facility: string;
  userName: string;
  email: string;
  bellNotificationsContentPath: string =
    '/Notification/BellNotificationsContent';
  isDev: boolean = false;
  isUat: boolean = false;
  userUuid: string;
  isShowDataScope: boolean = false;
  isShowSubscribtionScope: boolean = false;
  subscribeResults: any;
  isActiveOptions: any[];
  subscribtionColumns: any[];
  userSubscribtionParam: any;
  loginAccount: string;
  userType: string;
  topMenus: MenuItem[];
  searchKeyword: string = '';
  recentMenus: any[] = [];
  filteredMenus: any[] = [];
  allFlatMenus: any[] = [];
  showPanel = false;
  highlightedIndex: number = -1;
  debounceTimer: any;
  selectedMenu: any = null;
  searchWrapperRef!: ElementRef;

  @ViewChild('bellNotifyPanel') bellNotifyPanel?: OverlayPanel;
  @ViewChild('searchWrapper') set wrapper(ref: ElementRef) {
    if (ref) this.searchWrapperRef = ref;
  }

  constructor(
    injector: Injector,
    private notificationService: NotificationService,
    private commonDataService: CommonDataService,
    private notificationSubScriptionService: NotificationSubScriptionService,
    private menuDataService: MenuService,
    private router: Router,
    private primengConfig: PrimeNGConfig,
  ) {
    super(injector);
    this.facility = '';
    this.language = '';
    this.userName = '';
    this.email = '';
    this.userUuid = '';
    this.loginAccount = '';
    this.userType = '';

    this.topMenus = [];

    if (environment.environmentName == 'dev') {
      this.isDev = true;
    } else if (environment.environmentName == 'uat') {
      this.isUat = true;
    }

    this.isActiveOptions = [
      { label: 'Y', value: 1 },
      { label: 'N', value: 0 },
    ];

    this.subscribtionColumns = [
      {
        field: 'subscriberId',
        header: 'NotificationSubscribtion.Form.Subscriber',
        sort: true,
      },
      {
        field: 'notifyEventName',
        header: 'NotificationSubscribtion.Form.NotificationType',
        sort: true,
      },
      {
        field: 'tenantName',
        header: 'NotificationSubscribtion.Form.Tenant',
        sort: true,
      },
      {
        field: 'facilityName',
        header: 'NotificationSubscribtion.Form.Facility',
        sort: true,
      },
      {
        field: 'forwarderName',
        header: 'NotificationSubscribtion.Form.Forwarder',
        sort: true,
      },
      {
        field: 'customerName',
        header: 'NotificationSubscribtion.Form.Customer',
        sort: true,
      },
      {
        field: 'orgName',
        header: 'NotificationSubscribtion.Form.Org',
        sort: true,
      },
      {
        field: 'isByOwner',
        header: 'NotificationSubscribtion.Form.IsPersonalSubscription',
        sort: true,
      },
      {
        field: 'sendingMethod',
        header: 'NotificationSubscribtion.Form.NotificationMode',
        sort: true,
      },
      {
        field: 'isActivated',
        header: 'NotificationSubscribtion.Form.IsActived',
        sort: true,
      },
    ];

    this.userSubscribtionParam = {
      eventType: '',
      tenant: '',
      facility: '',
      forwarder: '',
      consigneeKey: '',
      subscriberId: '',
      orgId: '',
      language: '',
    };
  }

  async ngOnInit(): Promise<void> {
    // 呼叫父類別的 ngOnInit
    await super.ngOnInit();

    try {

      // 取得使用者 UUID
      this.userUuid = this.userProfile?.uuid;

      // 設定 SuperAdmin 權限
      devToolsConfig.isSuperAdmin = this.userProfile.userType === UserType.SuperAdmin;
      if (devToolsConfig.isSuperAdmin) {
        clearDetectorDetectInterval();
        disableKeyAndMenu(false);
      }

      // 語言設定
      this.language = this.laasSetting.language;
      this.languageOptions = [
        { label: 'English', value: 'en-us', abbreviation: 'EN' },
        { label: '繁體中文', value: 'zh-tw', abbreviation: '繁中' },
      ];
      this.languageData = this.languageOptions.find(opt => opt.value === this.language) ?? this.languageOptions[0];

      // 取得語言翻譯後再設定語言選項
      this.translateService.get('Common.Language.EnUs').subscribe(() => {
        this.languageOptions = [
          {
            label: this.translateService.instant('Common.Language.EnUs'),
            value: 'en-us',
            abbreviation: 'EN',
          },
          {
            label: this.translateService.instant('Common.Language.ZhTw'),
            value: 'zh-tw',
            abbreviation: '繁中',
          },
        ];
        this.languageData = this.languageOptions.find(opt => opt.value === this.language) ?? this.languageOptions[0];
        this.translateService.use(this.languageData.value);
      });

      // loading primeng i18n after BaseComponent call translateService.use(lang)
      this.translateService.get('primeng').subscribe({
        next: (result) => {
          this.primengConfig.setTranslation(result);
        }
      });

      // 取得頂部選單資料
      this.menuDataService.getMenuDataByPosition('Top', this.userUuid).subscribe({
        next: (topMenuItems) => {
          this.topMenus = this.convertToMenuItems(topMenuItems);
        },
      });

      // 取得所有授權選單
      this.menuDataService.getAllAuthorizedMenu(this.userUuid).subscribe({
        next: (resp: any[]) => {
          this.allFlatMenus = this.flattenMenus(resp);
        },
        error: (err: any) => {
          this.toastErrorMessage(err.error?.errorMsg);
        },
      });

      // 取得使用者最近搜尋選單
      this.getUserRecentSearchMenu();

      // 設定使用者資訊
      const { userName, email, loginAccount, userType } = this.userProfile;
      this.userName = userName;
      this.email = email;
      this.loginAccount = loginAccount;
      this.userType = userType;

      // 初始化 LAAS Portal 版本
      if (userType) {
        initLaasPortalVersion(this.commonDataService, userType);
      }

      // 初始化快取資料
      this.initCacheData(this.language);

      // 刷新 Token
      const userRefreshToken: UserRefreshToken = {
        facility: this.laasSetting.facility,
        language: this.laasSetting.language,
      };

      setTimeout(() => {
        this.authenticationService.refreshTokenBy(userRefreshToken);
      }, 1000);

      // 通知相關初始化
      this.notificationService.setUpdateBellNotifyFlag(true);
      this.getBellNotify(this.userProfile.uuid, false, true);

      // 關閉載入動畫
      this.loader.hide();
    } catch (err) {
      console.error('baseSession Error', err);
    }
  }

  private convertToMenuItems(beans: any[]): MenuItem[] {
    return beans.map((bean) => this.convertToMenuItem(bean));
  }

  private convertToMenuItem(bean: any): MenuItem {
    const menuItem: MenuItem = {
      label: this.getMenuLabelByLanguage(bean, this.laasSetting.language),
      icon: GlobalConstants.menuIconMap.get(bean.icon),
      routerLink: bean.routerLink,
      url: bean.url,
      command: () => {
        this.routeStateService.clear();
      },
      items: [],
    };

    if (bean.items && bean.items.length > 0) {
      menuItem.items = this.convertToMenuItems(bean.items);
    }

    return menuItem;
  }

  private getMenuLabelByLanguage(menu: any, lang: string): string {
    const normalizedLang = lang?.toLowerCase();
    switch (normalizedLang) {
      case 'en-us':
        return menu.nodeNameEN || '';
      case 'zh-tw':
        return menu.nodeNameTW || '';
      default:
        return '';
    }
  }

  getBellNotify(uuid: string, isSingleUpdate: boolean, isAuto: boolean): void {
    const isRead = this.showAllBellNotify ? null : 0;
    this.isLoading = true;
    this.notificationService
      .getBellNotifyByAuto(uuid, isRead, isAuto)
      .then((result) => {
        this.isLoading = false;

        if (!result) {
          return;
        }

        this.bellNotifications = result ?? [];
        const countNotRead =
          isRead === 0
            ? this.bellNotifications.length.toString()
            : this.bellNotifications
                .filter((x: any) => x.isRead === 0)
                .length.toString();
        const bellNotificationElement =
          document.getElementById('bellNotification');

        bellNotificationElement?.removeAttribute('data-count');
        if (countNotRead !== '0') {
          bellNotificationElement?.setAttribute('data-count', countNotRead);
        }
      });

    if (!isSingleUpdate) {
      setTimeout(
        () => this.getBellNotify(this.userProfile.uuid, false, isAuto),
        1000 * 2
      );
    }
  }

  updateBellNotidy(): void {
    this.getBellNotify(this.userProfile.uuid, true, false);
  }

  goToBellNotificationsPage(): void {
    this.bellNotifyPanel?.hide();
    this.routeStateService.navigateTo('/Notification/BellNotifications');
  }

  async goToBellNotificationsContentPage(notification: any): Promise<void> {
    this.bellNotifyPanel?.hide();

    const req = {
      markType: 'SelectedRow',
      seqNos: [notification.seqNo],
      uuid: this.userUuid,
    };

    let result = await this.notificationService.markRead(req).toPromise();


    if (isDeepLinkAvailable(notification.content)) {
      this.updateNotificationInformation(notification);
      this.useDeepLinkApproach(notification.content);
      return;
    }

    if (
      this.routeStateService.getCurrentUrl() &&
      this.routeStateService
        .getCurrentUrl()
        .substring(0, this.bellNotificationsContentPath.length) ===
        this.bellNotificationsContentPath
    ) {
      this.updateNotificationInformation(notification);
      return;
    }

    this.routeStateService.navigateTo(this.bellNotificationsContentPath, {
      uuid: this.userProfile.uuid,
      seqNo: notification.seqNo,
      isRead: notification.isRead,
      title: notification.title,
      content: notification.content,
    });
  }

  private updateNotificationInformation(notification: any): void {
    const notificationData = {
      uuid: this.userProfile.uuid,
      seqNo: notification.seqNo,
      isRead: notification.isRead,
      title: notification.title,
      content: notification.content,
    };
    this.routeStateService.updateData(
      this.bellNotificationsContentPath,
      notificationData
    );
  }

  private useDeepLinkApproach(content: string): void {
    const linkPath: any = extractLinkPath(content);
    if (!isNullOrEmpty(linkPath)) {
      window.location.href = linkPath;
    }
  }

  changeBellNotify(type: string): void {
    switch (type) {
      case 'all':
        this.showAllBellNotify = true;
        break;
      case 'unread':
        this.showAllBellNotify = false;
        break;
    }
    this.notificationService.setUpdateBellNotifyFlag(true);
    this.getBellNotify(this.userProfile.uuid, true, false);
  }

  toggleSideMenu(): void {
    this.menuDataService.toggleMenuBar.next(!this.menuDataService.toggleMenuBar.value);
  }

  languageChange(event: any): void {
    const selectedLangValue = event.value.value;
    this.laasSetting.language = selectedLangValue;
    this.languageData =
      this.languageOptions.find((opt) => opt.value === selectedLangValue) ??
      this.languageOptions[0];

    const userRefreshToken: UserRefreshToken = {
      facility: this.laasSetting.facility,
      language: selectedLangValue,
    };
    // 確保切換語系時DropdownList是最新語系
    this.authenticationService.refreshTokenBy(userRefreshToken).then(() => {
      this.commonDataService.getCodeConverter(selectedLangValue, 'DropdownList').subscribe({
        next: (codeConverters: any[]) => {
          const oldCacheStr = localStorage.getItem('laas_cache');
          let cacheObj: any = { dropdownList: { value: {} } };
          if (oldCacheStr) {
            try { cacheObj = JSON.parse(oldCacheStr); } catch (e) {}
          }
          if (!cacheObj.dropdownList) cacheObj.dropdownList = { value: {} };
          if (!cacheObj.dropdownList.value) cacheObj.dropdownList.value = {};
          cacheObj.dropdownList.value.DropdownList = codeConverters;
          cacheObj.dropdownList.value.DoStatus = codeConverters;
          localStorage.setItem('laas_cache', JSON.stringify(cacheObj));
          location.reload();
        },
        error: () => {
          location.reload();
        }
      });
    });
  }

  optionsDataOnChange(data: any, type: string): void {
    switch (type) {
      case 'facility':
        this.changeFacility(data);
        break;
    }
  }

  changeFacility(data: any): void {
    this.laasSetting.facility = data;
    const userRefreshToken: UserRefreshToken = {
      facility: this.laasSetting.facility,
      language: this.laasSetting.language,
    };
    this.authenticationService.refreshTokenBy(userRefreshToken).then(() => {
      location.reload();
    });
  }

  logout(): void {
    this.authenticationService.logout();
    window.location.reload();
  }

  private initCacheData(language: string): Observable<any> {
    const promise = new Promise<void>((resolve, reject) => {
      const tasks = [
        this.commonDataService.getCodeConverter(language, 'DropdownList'),
        this.commonDataService.getErrorCodes(language),
      ];
      zip(...tasks).subscribe({
        next: (results) => {
          const options = results[0] as any[];
          const optionGroup = _.groupBy(options, (x: any) => x.subCategory);
          this.cacheService.save(LaasConstants.dropdownListKey, optionGroup);

          const errorCodes = results[1] as any[];
          const errorCodeGroup = _.groupBy(errorCodes, (x: any) => x.category);
          this.cacheService.save(
            LaasConstants.errorCodeListKey,
            errorCodeGroup
          );

          resolve();
        },
        error: (err) => reject(err),
      });
    });
    return from(promise);
  }

  showDataScope() {
    //this.isShowDataScope = true;
    this.routeStateService.navigateTo('/User/userPreview');
  }

  showSubscritionScope() {
    //this.isShowSubscribtionScope = true ;
    this.routeStateService.navigateTo('/NotificationSubscribtion');
    //this.getUserNotufucationSubscribtion();
  }

  getUserNotufucationSubscribtion() {
    this.userSubscribtionParam.language = this.laasSetting.language;
    this.userSubscribtionParam.consigneeKey = [
      this.userSubscribtionParam.consigneeKey,
    ];
    this.userSubscribtionParam.subscriberId = [this.userProfile.email];
    this.notificationSubScriptionService
      .getUserSubscribe(
        this.userSubscribtionParam,
        this.loginAccount,
        this.userType
      )
      .subscribe({
        next: (result) => {
          this.subscribeResults = result;
        },
      });
  }

  getUserRecentSearchMenu() {
    this.menuDataService
      .getUserRecentSearchMenu(this.userUuid)
      .subscribe((menus) => {
        this.recentMenus = menus.map((menu) => ({
          label: this.getMenuLabelByLanguage(menu, this.laasSetting.language),
          nodeNameTW: menu.nodeNameTW,
          nodeNameEN: menu.nodeNameEN,
          url: menu.url,
          routerLink: menu.routerLink,
          menuSeqNo: menu.menuSeqNo,
        }));
      });
  }

  flattenMenus(menuResps: UserFavoriteMenuResp[]): UserFavoriteMenuItemBean[] {
    let result: UserFavoriteMenuItemBean[] = [];

    for (const resp of menuResps) {
      if (resp.subMenuList && resp.subMenuList.length) {
        const transformed = resp.subMenuList.map((item) => ({
          ...item,
          label: this.getMenuLabelByLanguage(item, this.laasSetting.language),
        }));
        result = result.concat(transformed);
      }
    }

    return result;
  }

  menuSearchInputChange() {
    clearTimeout(this.debounceTimer);
    this.selectedMenu = null;

    this.debounceTimer = setTimeout(() => {
      const query = this.searchKeyword?.toLowerCase()?.trim();

      if (!query) {
        this.filteredMenus = [...this.recentMenus];
        this.showPanel = true;
        this.highlightedIndex = -1;
        return;
      }

      this.filteredMenus = this.allFlatMenus.filter(
        (menu) =>
          menu.nodeNameEN?.toLowerCase().includes(query) ||
          menu.nodeNameTW?.toLowerCase().includes(query) ||
          menu.label?.toLowerCase().includes(query)
      );

      this.highlightedIndex = -1;
      this.showPanel = true;
    }, 300);
  }

  menuSearchKeydown(event: KeyboardEvent) {
    if (!this.filteredMenus || this.filteredMenus.length === 0) return;

    if (event.key === 'ArrowDown') {
      this.highlightedIndex =
        (this.highlightedIndex + 1) % this.filteredMenus.length;
      event.preventDefault();
    }

    if (event.key === 'ArrowUp') {
      this.highlightedIndex =
        (this.highlightedIndex - 1 + this.filteredMenus.length) %
        this.filteredMenus.length;
      event.preventDefault();
    }

    if (event.key === 'Enter') {
      if (this.highlightedIndex >= 0) {
        this.selectMenu(this.filteredMenus[this.highlightedIndex]);
      } else {
        const match = this.filteredMenus.find(
          (item) => item.label === this.searchKeyword
        );
        if (match) {
          this.selectMenu(match);
        } else {
          this.selectedMenu = null;
          this.showPanel = true;
        }
      }
    }

    if (event.key === 'Escape') {
      this.showPanel = false;
    }
  }

  menuSearchFocus() {
    const query = this.searchKeyword?.toLowerCase()?.trim();
    if (!query) {
      this.filteredMenus = [...this.recentMenus];
      this.showPanel = true;
      this.highlightedIndex = -1;
    } else {
      this.menuSearchInputChange();
    }
  }

  selectMenu(menu: any) {
    this.selectedMenu = menu;
    this.searchKeyword = menu.label;
    this.showPanel = false;

    if (!menu || isNullOrEmpty(menu.menuSeqNo)) return;

    if (!this.recentMenus.some((x) => x.menuSeqNo == menu.menuSeqNo)) {
      const request = {
        uuid: this.userUuid,
        menuSeqNo: menu.menuSeqNo,
      };
      this.menuDataService.saveUserRecentSearchMenu(request).subscribe();
      this.recentMenus.unshift(menu);
    }

    if (!isNullOrEmpty(menu.routerLink)) {
      window.location.href = menu.routerLink;   //直接用 window.location.href，讓瀏覽器重整跳轉
    } else if (!isNullOrEmpty(menu.url)) {
      window.open(menu.url, '_blank');    //外部連結的話，新開分頁
    }
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (!this.searchWrapperRef?.nativeElement.contains(event.target)) {
      this.showPanel = false;
    }
  }
}
